import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ArticulosGeneral, EcommerceGenericoService, HistorialPedidos, ItemsMMaxResumen } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { MenuMmaxInterface } from '../etc/mmax-menu.interface';
import { MarianomGeneral } from '../marianom-general.service';

@Component({
  selector: 'historial-generic-wiew',
  templateUrl: './historial-generic-wiew.component.html',
  styleUrls: ['./historial-generic-wiew.component.scss']
})

export class HistorialGenericWiewComponent implements OnInit {
  @Input() pedidoH: HistorialPedidos;
  @Input() displayPagoDiferido: string="none";
  @Output() onClick: EventEmitter<HistorialPedidos>= new EventEmitter();
  @Output() onRepat: EventEmitter<HistorialPedidos>= new EventEmitter();

  pagoDiferido: string="";
  articulosDePedido: ArticulosGeneral[] = [];
  costoFlete: number=0;
  constructor(private serv: MarianomGeneral, private router: ActivatedRoute,  private genServ: EcommerceGenericoService) {
    
    this.genServ.getPagoDiferido().subscribe(data => {
      this.pagoDiferido = data
    });
  }

  ngOnInit(): void {
    if (this.genServ.isEnEsperaDePago(this.pedidoH)) {
      if (this.pagoDiferido !== "E") this.displayPagoDiferido = "flex";
    } else {
      this.displayPagoDiferido = "none";
    }
        
    this.articulosDePedido = this.pedidoH.itemsreales.filter((itemsPedido: ArticulosGeneral) => {
      const esMarcaFlete = Number(itemsPedido.marca) === Number(this.genServ.marcaFlete);
      const esCodigoFlete = Number(itemsPedido.codigo) === Number(this.genServ.codigoFlete);

      if (esMarcaFlete && esCodigoFlete) {
        this.costoFlete = itemsPedido.getPrecio();
        return false; 
      } else return true; 
    });
  }

  get menus(): MenuMmaxInterface[] {
    return this.serv.rutas
  }

  verDetalle() {
    this.onClick.emit(this.pedidoH);
  }

  pagar() {
    this.genServ.resetEccomerce();
    this.genServ.cargarEstePedidoDeHistorialEnCart(this.pedidoH);
    this.genServ.guardarpedido(this.pedidoH);
    this.serv.navigator.precierreCheckout(this.router);
    setTimeout(() => {
      this.serv.navigator.cierreCheckout(this.router);

    }, 50);
  }

  repetirCompra() {
    for (let i = 0; i < this.menus.length; i++) {
      const element = this.menus[i];
      element.activo = false;
    }
    this.onRepat.emit(this.pedidoH);
  }

  get ocultarPrecios() {
    return this.genServ.isOcultarPrecio()
  }

  get statusLabel(): string {
    return this.genServ.getStatusDisplay(this.pedidoH);
  }

  get statusClass(): string {
    return this.genServ.getClassStatus(this.pedidoH);
  }
}
